import React from 'react';
import PasswordInputField from '../../../BuildingBlocks/Form/PasswordInputField';

export default function PasswordFields({ errors, register }) {
  return (
    <>
      <PasswordInputField
        errors={errors}
        label={'Password'}
        name={'password'}
        TextFieldProps={{
          ...register('password'),
        }}
      />
      <PasswordInputField
        errors={errors}
        label={'Re-enter password'}
        name={'passwordConfirm'}
        TextFieldProps={{
          ...register('passwordConfirm'),
        }}
      />
    </>
  );
}
